<template>
    <div class="row filters justify-content-between">
        <div class="col-12 col-sm-6 col-lg-3">
            <div class="dropdown">
                <a class="dropdownBTN w-100 mb-3" href="#" role="button" id="sorting" data-toggle="dropdown">
                    {{ this.sortby }}
                </a>
                <div class="dropdown-menu" aria-labelledby="sorting">
                    <a class="dropdown-item" href="?over=asc" v-if="logedin">Überboten</a>
                    <a class="dropdown-item" href="?high=asc" v-if="logedin">Höchstbieter</a>
                    <a class="dropdown-item" href="?time=asc">Kürzester Countdown</a>
                    <a class="dropdown-item" href="?pos=asc">Positionen Aufsteigend</a>
                    <a class="dropdown-item" href="?bid=asc">Niedrigstes Gebot</a>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-6 col-xl-4 text-right">
            <a href="/beobachtungsliste" role="button" class="btn btn-info w-100 mr-3" v-if="logedin">Beobachtungsliste</a>
            <a href="/gebotsliste" role="button" class="btn btn-success login w-100" v-if="logedin">Gebotsliste</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: [Boolean],
                required: true,
                default: false
            },

            sortby: {
                type: [String],
                required: false,
                default: false
            }
        },

        data () { 
            return {
                logedin: false
            }
        },

        created() {
            this.logedin = this.user;
            App.event.listen('login.success', (response) => {
                this.logedin = true;
            });
        }
    }
</script>
